import i18n from "i18next";

export enum CheckInStatus {
  WAITING = "WAITING",
  IN_PROGRESS = "IN_PROGRESS",
  CLOSED = "CLOSED",
}

export const EventStatusToString = (status?: CheckInStatus): string => {
  let stringKey;
  if (status === CheckInStatus.WAITING) {
    stringKey = "common_status_announceattendee";
  } else if (status === CheckInStatus.IN_PROGRESS) {
    stringKey = "common_status_incheckin";
  } else if (status === CheckInStatus.CLOSED) {
    stringKey = "common_status_checkinend";
  }
  return stringKey ? i18n.t(stringKey) : "";
};

export const EventStatusStyle = (status: CheckInStatus): string => {
  let style;
  if (status === CheckInStatus.WAITING) {
    style = "badge-secondary";
  } else if (status === CheckInStatus.IN_PROGRESS) {
    style = "badge-accent";
  } else if (status === CheckInStatus.CLOSED) {
    style = "badge-ghost";
  }
  return style || "";
};
